import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { __ } from '../../locales';
import HOC from '../HOC';
import MisunderstoodMaterials from './components/MisunderstoodMaterials';
import RecyclingFundamentals from './components/RecyclingFundamentals';
import RcKids from './components/RcKids';
import BlogPosts from './components/BlogPosts';
import RecycleRIGHTGame from './components/RecycleRIGHTGame';
import images from '../../images';
import { trackEvent } from '../../helpers/common';
import events from '../../app/events';
import LearningModules from './components/LearningModules';

const Container = styled.div`
  padding: 15px 12px;
  margin-top: -100px;
`;

const PageTitle = styled.h1`
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const CustomHeader = styled.div`
  background: linear-gradient(#fff, #fff, ${(props) => props.mainColor});
  background-position: center -10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: 'transparent';
  height: 310px;
  padding: 12px;
  margin-left: -12px;
  margin-top: 15px;
  margin-right: -12px;
  clip-path: polygon(
    100% 0%, 0% 0% , 0% 97.50%, 1% 97.49%, 2% 97.47%, 3% 97.42%, 4% 97.36%, 5% 97.29%, 6% 97.20%, 7% 97.09%, 8% 96.96%, 9% 96.82%, 10% 96.67%, 11% 96.49%, 12% 96.31%, 13% 96.11%, 14% 95.89%, 15% 95.67%, 16% 95.43%, 17% 95.17%, 18% 94.91%, 19% 94.63%, 20% 94.35%, 21% 94.05%, 22% 93.75%, 23% 93.43%, 24% 93.11%, 25% 92.78%, 26% 92.45%, 27% 92.11%, 28% 91.76%, 29% 91.42%, 30% 91.06%, 31% 90.71%, 32% 90.35%, 33% 90.00%, 34% 89.64%, 35% 89.28%, 36% 88.93%, 37% 88.58%, 38% 88.23%, 39% 87.88%, 40% 87.54%, 41% 87.21%, 42% 86.88%, 43% 86.56%, 44% 86.24%, 45% 85.94%, 46% 85.64%, 47% 85.36%, 48% 85.08%, 49% 84.82%, 50% 84.57%, 51% 84.33%, 52% 84.10%, 53% 83.89%, 54% 83.69%, 55% 83.50%, 56% 83.33%, 57% 83.17%, 58% 83.03%, 59% 82.91%, 60% 82.80%, 61% 82.71%, 62% 82.63%, 63% 82.58%, 64% 82.53%, 65% 82.51%, 66% 82.50%, 67% 82.51%, 68% 82.53%, 69% 82.58%, 70% 82.64%, 71% 82.71%, 82% 82.81%, 73% 82.92%, 74% 83.04%, 75% 83.18%, 76% 83.34%, 77% 83.51%, 78% 83.70%, 79% 83.90%, 80% 84.11%, 81% 84.34%, 82% 84.58%, 83% 84.83%, 84% 85.10%, 85% 85.37%, 86% 85.66%, 87% 85.96%, 88% 86.26%, 89% 86.57%, 90% 86.90%, 91% 87.22%, 92% 87.56%, 93% 87.90%, 94% 88.24%, 95% 88.59%, 96% 88.95%, 97% 89.30%, 98% 89.66%, 99% 90.01%, 100% 90.37%);
`;

const Header = styled.div`
  background-image: url(${images.header_bg});
  background-position: center -10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: 'transparent';
  height: 280px;
  width: 100%;
  padding: 12px;
  margin-left: -12px;
  margin-top: 15px;
  margin-right: -12px;
`;

const Logo = styled.img`
  width: 200px;
  margin-top: 40px;
  margin-left: -10px;
  object-fit: contain;
  display: block;
`;

const Landing = ({
  discoveryData,
  gamificationData,
  quizData,
  recycleRight,
  rrGameOnly,
  kidsData,
  notificationData,
  viewedEducationData,
  mainColor,
  dzBrandConfigs,
}) => {
  const { push } = useHistory();
  const { hasPassedRfQuiz, hasPassedMmQuiz, hasPassedLmQuiz } = gamificationData;
  const {
    misundestoodMaterials, recyclingFundamentals, learningModules, blogPosts
  } = discoveryData;

  const viewedRFLessons = viewedEducationData?.rfLessons || [];
  const viewedMuisunderstoodMaterials = viewedEducationData
    ?.misundestoodMaterials || [];
  const viewedLearningModules = viewedEducationData
    ?.learningModules || [];

  const [hasLmNotification, setHasLmNotification] = useState();

  /**
   * Check 6 different Edge Cases for Recycle RIGHT game
   * If one of the edge cases were detetced in the data,
   * the Recycle RIGHT game will not appear in Discovery Zone page
   */
  const checkEdgeCaseRecycleRIGHT = () => {
    let hasNullMaterial = false;
    let redundantMatId = false;
    let hasNotRequiredKey = false;
    let notStandardlevelKey = false;
    const recycleRightData = recycleRight.allRrData;

    /**
     * Edge Case 1:
     * If recycleRIGHT does not exist in Discovery Zone data
     */
    if (!recycleRightData) return false;
    /**
     * Edge Case 2:
     * If recycleRIGHT is empty
     */
    if (Object.keys(recycleRightData).length === 0) return false;
    /**
     * Edge Case 3:
     * If a level key name is not standard
     */
    Object.keys(recycleRightData).forEach((level, index) => {
      if (level !== `level_${index + 1}_materials`) {
        notStandardlevelKey = true;
      }
    });

    if (notStandardlevelKey) return false;

    /**
     * Edge Case 4:
     * If a level does not have any material
     */
    Object.keys(recycleRightData).forEach((level) => {
      if (recycleRightData[level].length === 0) hasNullMaterial = true;
    });

    if (hasNullMaterial) return false;

    /**
     * Edge Case 5:
     * If a mat_id was redundant in recycleRIGHT
     */
    const all_mat_id = [];
    Object.keys(recycleRightData).forEach((key) => {
      recycleRightData[key].forEach((element) => {
        if (all_mat_id.indexOf(element.mat_id) !== -1) {
          redundantMatId = true;
        } else {
          all_mat_id.push(element.mat_id);
        }
      });
    });

    if (redundantMatId) return false;

    /**
     *
     * Edge Case 6:
     * If a material does not have all the required keys or one of the keys value is null
     */
    const materialKeys = ['disposal_body', 'disposal_header', 'is_recyclable', 'mat_id', 'mat_image', 'mat_nm', 'oidx'];

    Object.keys(recycleRightData).forEach((key) => {
      recycleRightData[key].forEach((material) => {
        materialKeys.forEach((requiredKey) => {
          if (!(requiredKey in material) || material[requiredKey] === null) {
            hasNotRequiredKey = true;
          }
        });
      });
    });

    if (hasNotRequiredKey) return false;

    return true;
  };
  useEffect(() => {
    trackEvent(events.DZ_HOME_LAND);

    if (rrGameOnly && checkEdgeCaseRecycleRIGHT()) {
      push('/recycle-right-initial');
    }
  }, [recycleRight.allRrData, rrGameOnly]);

  useEffect(() => {
    if (notificationData?.campaign_id) {
      setHasLmNotification(true);
    }
  }, []);

  const brandLogo = dzBrandConfigs?.logo;
  const introText = dzBrandConfigs?.dzTextConfig?.introText;

  return (
    <Container>
      {brandLogo && (
        <Logo
          src={brandLogo}
          alt="logo"
        />
      )}
      {mainColor ? (
        <CustomHeader mainColor={mainColor}>
          <PageTitle style={{ marginTop: brandLogo ? 0 : 40 }}>
            {__('app.discovery_zone')}
          </PageTitle>
          <p>
            {introText || __('app.weve_been_taught_to_recycle')}
          </p>
        </CustomHeader>
      )
        : (
          <Header>
            <PageTitle style={{ marginTop: brandLogo ? 0 : 40 }}>
              {__('app.discovery_zone')}
            </PageTitle>
            <p>
              {introText || __('app.weve_been_taught_to_recycle')}
            </p>
          </Header>
        )}

      {
        learningModules?.map((item, lmIndex) => (
          <LearningModules
            lessons={item}
            quizData={quizData}
            hasPassedLmQuiz={hasPassedLmQuiz}
            accountId={window.accountId}
            lmIndex={lmIndex}
            hasLmNotification={hasLmNotification}
            viewedLearningModules={viewedLearningModules}
          />
        ))
      }

      {Object.values(recyclingFundamentals).length > 0 ? (
        <RecyclingFundamentals
          lessons={recyclingFundamentals}
          quizData={quizData}
          hasPassedRfQuiz={hasPassedRfQuiz}
          accountId={window.accountId}
          viewedRFLessons={viewedRFLessons}
        />
      ) : null}

      {Object.values(misundestoodMaterials).length > 0
        ? (
          <MisunderstoodMaterials
            lessons={misundestoodMaterials}
            hasPassedMmQuiz={hasPassedMmQuiz}
            quizData={quizData}
            accountId={window.accountId}
            viewedMuisunderstoodMaterials={viewedMuisunderstoodMaterials}
          />
        ) : null}

      {kidsData && <RcKids />}

      {blogPosts && Object.values(blogPosts).length > 0 && <BlogPosts posts={blogPosts} />}

      {checkEdgeCaseRecycleRIGHT() && <RecycleRIGHTGame />}

    </Container>
  );
};

export default HOC(Landing);
